<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('nivels')">Nivel</inertia-link>
      <span class="text-white font-medium">/Crear</span>
    </h1>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" required/>
          <text-input v-model="form.description" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Descripción"/>

            </div>
        <div class="px-8 py-4 bg-transparent flex justify-end items-center">
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-2 btn-indigoOrange" type="submit">Agregar</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Agregar Nivel' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    users: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        description: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('nivels.store'))
    },
  },
}
</script>
